import Text from 'components/Text/Text';
import React, { useContext, useState, useEffect } from 'react';
import {
	IFirmwareAssignmentContext,
	FirmwareAssignmentContext,
} from '../../../../firmwareAssignmentState/firmwareAssignmentContext';
import Button from 'components/Button/Button';
import breadcrumbs from 'images/breadcrumbs.svg';
import style from './CancelAndSaveButtons.module.scss';

const CancelAndSaveButtons: React.FC = () => {
	const { changeTypeOfModalWindow, IDsSelectedCustomers, firmwares } =
		useContext<IFirmwareAssignmentContext>(FirmwareAssignmentContext);
	const [isActiveSaveBtn, setIsActiveSaveBtn] = useState<boolean>(true);

	useEffect(() => {
		const someFirmwareChanged = firmwares.some((el) => el.isChanged);
		setIsActiveSaveBtn(someFirmwareChanged);
	}, [firmwares]);

	return (
		<div className={style.container} data-test="CancelAndSaveButtons">
			<Button
				className={style.cancelBtn}
				theme="outlined"
				onClick={() => changeTypeOfModalWindow('toConfirmFieldsClearing')}
				disabled={!Object.keys(IDsSelectedCustomers).length}
				icon={
					<svg className={style.icon}>
						<use xlinkHref={`${breadcrumbs}#resetIcon`} />
					</svg>
				}>
				<Text translationNameSpace="listing" translationKey="cancelButton" asFragment={true} />
			</Button>

			<Button
				className={style.saveBtn}
				theme="primaryBlue"
				onClick={() => changeTypeOfModalWindow('toConfirmSendChanges')}
				disabled={!isActiveSaveBtn}>
				<Text translationNameSpace="listing" translationKey="saveButton" asFragment={true} />
			</Button>
		</div>
	);
};

export default CancelAndSaveButtons;
